const seoConfig = {
    policy: {
        title: "Legal & Policies | Wryven",
        description: "Read Wryven's Terms of Service, Privacy Policy, and Cookies Policy.",
        keywords: "Terms of Service, Privacy Policy, Cookies Policy, Wryven Legal"
    }
};

export default seoConfig;